import * as userApi from 'resources/user/user.api';

import userService from 'resources/user/user.service';
import dealService from 'resources/deal/deal.service';
import auditService from 'resources/audit/audit.service';

import * as userOperations from 'resources/user/user.operations';

import * as userHelpers from 'resources/user/user.helpers';
import * as companyHelpers from 'resources/company/company.helpers';

import companyService from 'resources/company/company.service';

import { generateTransactionListedKit } from 'resources/listedkit/workflows/generateTransactionListedKit';

import { completeAudit } from 'resources/audit/workflows/completeAudit';

import { editTransactionDetails } from './editTransactionDetails';
import { DEAL_STATUSES } from '../deal.constants';

const onStartTransactionFinish = async (deal) => {
  const audits = await auditService.getPreContractAuditsByDealId(deal.id);

  if (audits?.length) {
    await Promise.all(audits.map(async (audit) => completeAudit({ auditId: audit.id })));
  }

  return Promise.all(deal.client_ids.map(async (clientId) => {
    const client = await userService.findById(clientId);

    return Promise.all([
      userOperations.actualizeClientStatusAndRoles(clientId),
      (userHelpers.isRegistered(client) && userApi.sendDealUnderContractEmail({
        deal,
        clientEmail: client.email,
      })),
    ]);
  }));
};

const startTransaction = async ({
  dealId,
  milestonesWithTasks,
  transactionDetails,
  eSignDocuments,
  createTransactionDocuments,
  dealStage,
}) => {
  const deal = await dealService.findById(dealId);
  const company = await companyService.findById(deal.company_id);
  const isEsignatureEnabled = companyHelpers.isEsignatureEnabled(company);

  if (!deal) {
    return;
  }

  const updatedDeal = await editTransactionDetails({
    dealId: deal.id,
    transactionDetails,
    // shouldStartTransaction: DEAL_STATUSES.ACTIVE,
    status: DEAL_STATUSES.ACTIVE,
  });

  const createdListedKit = await generateTransactionListedKit({
    deal,
    dealStage,
    milestonesWithTasks,
  });

  if (isEsignatureEnabled && eSignDocuments?.length) {
    await createTransactionDocuments({
      documentIds: eSignDocuments.map((doc) => doc.id),
      listedKitId: createdListedKit.id,
      dealId: deal.id,
    });
  }

  await onStartTransactionFinish(updatedDeal);

  return updatedDeal;
};

export {
  startTransaction,
};
